import React from "react";
import KineticHero from "@/components/KineticHero";
import {
  TrustBar,
  StatsBar,
  ServicesGrid,
  HomeMarquee,
  AboutPreview,
  Testimonials,
} from "@/components/sections";
import { CTABanner } from "@/components/ui-blocks";

export default function Home() {
  return (
    <div data-testid="home-page">
      <KineticHero />
      <TrustBar />
      <StatsBar />
      <HomeMarquee />
      <ServicesGrid />
      <AboutPreview />
      <Testimonials />
      <CTABanner
        eyebrow="Start a Project"
        heading={<>Let&apos;s build{"\n"}something{"\n"}great together.</>}
        sub="Send us your project scope and we'll respond within one business day with a preliminary approach and next steps."
      />
    </div>
  );
}
